import { followingSidebar } from '../../utils/sidebar.utils.js';

const jobPostSection = document.querySelector('.job-post-sec');

if (jobPostSection) {
  jobPostSection.closest('#site')?.classList.add('is-visible');

  const desktopBreakpoint = 881;
  const sidebar = jobPostSection.querySelector('.job-post-sec__aside');
  const contentSticky = jobPostSection.querySelector('.job-post-sec__wrap');
  const asideRolesWrapper = jobPostSection.querySelector('.job-post-sec__aside-roles-wr');
  const rolesWrapper = jobPostSection.querySelector('.job-post-sec__roles-wr');
  const rolesPlaceholder = document.createComment('job-post-roles-placeholder');
  let followingSidebarInstance = null;

  const updateFollowingSidebar = () => {
    if (!sidebar || !contentSticky) return;

    if (window.innerWidth < desktopBreakpoint) {
      followingSidebarInstance?.destroy();
      followingSidebarInstance = null;
      return;
    }

    followingSidebarInstance ??= followingSidebar({ sidebar, contentSticky, bottomGap: 40 });
    followingSidebarInstance?.refresh();
  };

  const updateSidebarOffset = () => {
    const sectionTop = jobPostSection.getBoundingClientRect().top + window.scrollY;
    const sidebarTop = sidebar.getBoundingClientRect().top + window.scrollY;
    const offset = Math.max(0, sidebarTop - (sectionTop + 10));

    sidebar.style.setProperty('--job-post-aside-top-offset', `${offset}px`);
  };

  let updateFrame = null;

  const throttledUpdateSidebarOffset = () => {
    if (updateFrame) {
      return;
    }

    updateFrame = requestAnimationFrame(() => {
      updateFrame = null;
      updateSidebarOffset();
    });
  };

  if (sidebar) {
    throttledUpdateSidebarOffset();
    window.addEventListener('resize', throttledUpdateSidebarOffset);
  }

  if (asideRolesWrapper && rolesWrapper && asideRolesWrapper.parentNode) {
    asideRolesWrapper.parentNode.insertBefore(rolesPlaceholder, asideRolesWrapper);

    const updateRolesPosition = () => {
      const shouldMoveRoles = window.innerWidth < desktopBreakpoint;

      if (shouldMoveRoles && asideRolesWrapper.parentNode !== rolesWrapper) {
        rolesWrapper.appendChild(asideRolesWrapper);
      }

      if (!shouldMoveRoles && asideRolesWrapper.parentNode !== rolesPlaceholder.parentNode) {
        rolesPlaceholder.parentNode.insertBefore(asideRolesWrapper, rolesPlaceholder.nextSibling);
      }
    };

    let rolesUpdateFrame = null;

    const throttledUpdateRolesPosition = () => {
      if (rolesUpdateFrame) {
        return;
      }

      rolesUpdateFrame = requestAnimationFrame(() => {
        rolesUpdateFrame = null;
        updateRolesPosition();
      });
    };

    throttledUpdateRolesPosition();
    window.addEventListener('resize', throttledUpdateRolesPosition);
  }

  if (sidebar && contentSticky) {
    updateFollowingSidebar();
    window.addEventListener('resize', updateFollowingSidebar, {passive: true});
  }
}
